/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".color-input[_ngcontent-%COMP%]{cursor:pointer;border-radius:50%;width:24px;height:24px;border:1px solid #ccc}.step-content[_ngcontent-%COMP%]{max-height:45vh;width:100%;overflow-y:auto;overflow-x:hidden;padding-top:2%}.step-actions[_ngcontent-%COMP%]{height:5vh;width:100%;position:absolute;bottom:0;left:0;padding:3% 2%;display:flex;align-items:center;justify-content:flex-end}\n/*# sourceMappingURL=wizard.component.css.map*/"];
export { styles as styles };
